export enum VacationBaseBuyKind {
  /// <summary>
  /// مقداز بازخرید
  /// </summary>
  VactaionBuyBack = 1,
  /// <summary>
  /// مانده مرخصی
  /// </summary>
  VactaionRemain = 2,
}
export enum VacationBuyKind {
  /// <summary>
  /// انفرادی
  /// </summary>
  Single = 1,
  /// <summary>
  /// گروهی
  /// </summary>
  Group = 2,
}
